import { Button, H2, Image, P, theme } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import styled from 'styled-components';

import { Article } from '../../../../types/__codegen__/sanity/graphql';
import ArticleMetadata from '../../../blog-detail/components/article-metadata';
import getImageAttributes from '../../../../cms/utils/get-image-attributes';

const { colors, media, mediaQueries } = theme;

const Container = styled.div`
  background-color: ${colors.grey10};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
  padding: 2rem 1rem;

  ${mediaQueries.above(media.lg)} {
    gap: 5rem;
    flex-direction: row;
    padding: 3rem;
  }
`;

const FeaturedTag = styled(P)`
  color: ${colors.purple};
  font-size: 1.5rem;
`;

const ImageContainer = styled.div`
  display: none;

  ${mediaQueries.above(media.lg)} {
    display: flex;
    justify-content: center;
  }
`;

type FeaturedArticleProps = {
  featuredArticle: Article | null;
};

const FeaturedArticle = ({ featuredArticle }: FeaturedArticleProps) => {
  if (isEmpty(featuredArticle)) {
    return null;
  }

  const { descriptionRaw, identifier, imageObject, insuranceType, name } = featuredArticle;
  const description = portableTextToPlain(descriptionRaw);
  const type = insuranceType?.identifier?.current;
  const slug = identifier?.current;
  const url = `/${type}-insurance/articles/${slug}`;

  const imageProps = getImageAttributes({ imageObject, width: 500 });

  return (
    <Container>
      <div>
        <FeaturedTag variant={['marginBottomSpacer9', 'simpleBit']}>Featured article</FeaturedTag>
        <H2 variant="marginBottomSpacer9">{name}</H2>
        <ArticleMetadata isLeftAligned article={featuredArticle} />
        {description && <P variant="marginBottomSpacer9">{description}</P>}
        <Button to={url} variant={['flair', 'wide']}>
          Read article
        </Button>
      </div>
      {imageProps && (
        <ImageContainer>
          <Image {...imageProps} />
        </ImageContainer>
      )}
    </Container>
  );
};

export default FeaturedArticle;
